var ikemath = require('@ikegps/math');
angular.module(
    'ikegps.math', []
).provider('ikemath', function() {
    return {
        $get: function() {
            return ikemath;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./src/client/ikegps.math.provider.js
// module id = 420
// module chunks = 0